import React from 'react';
import styled from 'styled-components';
import { Button } from '~/shared/components';
import { DataFilterModalButtonProps } from '../types';

const StyledButton = styled(Button)`
  && {
    min-width: 98px;
    height: 40px;
    margin: 0;
    padding: 7px 15px 6px;
    font-size: 14px;
    font-weight: 400;
    border-radius: 4px;
  }

  &&.button-secondary {
    color: #33485e;
    background: transparent;
    border: 1px solid #33485e;
    margin-right: 16px;

    &:hover {
      border-color: var(--button-ghost-hover-border);
    }

    &:active {
      border-color: var(--button-ghost-hover-border);
    }
  }
`;

const DateFilterModalButton = ({ text, onClick, secondary }: DataFilterModalButtonProps) => {
  return (
    <StyledButton onClick={onClick} className={secondary ? 'button-secondary' : 'button-primary'} secondary={secondary}>
      {text}
    </StyledButton>
  );
};

export default DateFilterModalButton;
